<div class="scroll-indicator">
    <div class="scroll-indicator-container">
        <div class="progress-container">

        </div>
        <label class="bold product-title">Scroll</label>
    </div>
</div>
